(function(){
    'use strict';

    angular.module('Services').factory('TableHelpers', TableHelpers);
    TableHelpers.$inject = [];

    function TableHelpers() {
        return {
            buildBreakBulkDetails: (breakBulkDetails) => {
                if (!angular.getObjVal(breakBulkDetails, 'name')) {
                    return ['N/A'];
                }

                const name =  angular.getObjVal(breakBulkDetails, 'name');
                const consignmentNo = angular.getObjVal(breakBulkDetails, 'consignmentId');
                const deliveredDate = angular.getObjVal(breakBulkDetails, 'deliveryDate')
                const manifestNo = angular.getObjVal(breakBulkDetails, 'manifestNumber');
                return [
                    name,
                    consignmentNo,
                    `Delivered: ${deliveredDate ? $filter('bbaDate')(deliveredDate, false, 'dd/MM/yyyy') : 'N/A'}`,
                    `Manifest No: ${manifestNo || 'N/A'}`
                ];
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/helpers/TableHelpers.js